.footer {
  background: var(--paper-band);
  border-top: 1px solid var(--rule);
}

.columns {
  padding-block: clamp(36px, 4vw, 52px) 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: clamp(26px, 4vw, 44px);
  align-items: start;
}

.about {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.blurb {
  font-size: 14px;
  line-height: 1.6;
  color: var(--ink-muted);
  max-width: 30ch;
}

/* The cross-link to DiabetesNinja. Sits with the blurb rather than in a column: it is a
   sentence about who made this, not a navigation item. */
.sibling {
  font-size: 14px;
  line-height: 1.6;
  color: var(--ink-muted);
  max-width: 34ch;
}

.siblingLink {
  color: var(--ink);
  text-decoration: underline;
  text-underline-offset: 3px;
  white-space: nowrap;
}

.column {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.columnTitle {
  font-family: var(--font-body);
  font-size: 13px;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: var(--ink);
  margin-bottom: 4px;
}

.link {
  font-size: 14px;
  color: var(--ink-muted);
  padding-block: 8px;
}

.link:hover {
  color: var(--ink);
}

.small {
  font-size: 14px;
  line-height: 1.6;
  color: var(--ink-muted);
  padding-top: 4px;
}

.baseline {
  padding-block: 18px 30px;
  border-top: 1px solid var(--rule);
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
  align-items: baseline;
  justify-content: space-between;
  font-size: 13px;
  line-height: 1.6;
  color: var(--ink-muted);
}
